module.exports = __webpack_public_path__ + "img/keuntungan.7892bf04.png";